import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import {
  extensionCheck,
  getExtensionList,
  getSubscriptionList,
  newcategorySubscription,
  shopPackage,
} from "../../restApi/api";
import { decrypt } from "../../utils/crypto";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import { Package_detail_Api } from "../../gql/queries";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { useQuery } from "@apollo/client";
import { firebaseData } from "../../firebase";
import { toast, ToastContainer } from "react-toastify";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { Modal } from "react-bootstrap";
import { trackEvent } from "../../utils/moengageUserSetup";

export default function SubsciptionHome() {
  let { name } = useParams();
  let navigate = useNavigate();
  const location = useLocation();
  const [config, setConfig] = useState();
  const [remoteLoading, setRemoteLoading] = useState(true);
  let [loader, setloader] = useState(true);
  let [categorylist, setCategory] = useState([]);
  const [shop, setShop] = useState([]);
  // const [extend, setExtendData] = useState([]);
  const [indexs, setIndex] = useState(parseInt(0));
  let [packageId, setPackageId] = useState("");
  let [subshowbutton, setsubshowbutton] = useState(false);
  let [isEligible, setEligible] = useState(false);
  let [extensionData, setExtensionData] = useState(true);
  const [EligibilityCriteriaData, setEligibilityCriteriaData] = useState();
  const showToast = (message) => {
    toast.success(message);
  };

  const [showPopup, setshowPopup] = useState(false);
  const showPopupCriteria = () => setshowPopup(true);
  const hidePopup = () => setshowPopup(false);
  const [criteria, setCriteria] = useState(null);
  const showToastError = (message) => {
    toast.error(message);
  };

  const newcategorylist = async () => {
    await newcategorySubscription()
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.success == true) {
          setloader(false);
          let arr = [];
          data.data.map((obj) => {
            if (obj.category != undefined) {
              arr.push(obj);
            }
          });
          categorylist = arr;
          setCategory(arr);
          if (name != undefined) {
            categorylist?.map((obj, i) => {
              if (obj?.category === name) {
                setData(obj);
              }
            });
          } else {
            if (categorylist[0]?.category?.indexOf("/")) {
              navigate(
                `/package/${(categorylist[0]?.category).replace(/\//g, "%2F")}`
              );
            } else {
              navigate(`/package/${categorylist[0]?.category}`);
            }
            setData(categorylist[0]);
          }
        }
      })
      .catch((error) => {
        setloader(false);
      });
  };
  const navigateToPlanAddons = (obj) => {
    extensionData = obj;
    setExtensionData(obj);
    const data = {
      packageId: obj?._id,
    };
    extensionCheck(data)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data?.success == true) {
          if (data?.data?.orderEligibleForExtension !== null) {
            isEligible = true;
            setEligible(true);
          } else {
            isEligible = false;
            setEligible(false);
          }
        } else {
          showToastError(data?.message);
        }
      })
      .catch((error) => {
        showToastError("Something went wrong please try agian");
      });
  };
  if (isEligible == true) {
    navigate("/package/extension", { state: JSON.stringify(extensionData) });
  }
  const setData = (data) => {
    query1.refetch({ categoryId: data?._id, packageType: "SUBSCRIPTION" });
    setPackageId(data?._id);
  };
  useEffect(() => {
    newcategorylist();
  }, []);
  useEffect(() => {
    const getConfigData = async () => {
      try {
        const remoteData = await firebaseData("e_shop_tab_list"); // Replace 'your_config_key' with the actual key for the configuration value you want
        setConfig(JSON.parse(remoteData));
        const EligibilityCriteria = await firebaseData("eligibility_criteria");
        setEligibilityCriteriaData(JSON.parse(EligibilityCriteria));
        setRemoteLoading(false);
      } catch (error) {
        console.error("Error fetching remote data:", error);
        setRemoteLoading(false);
      }
    };

    if (typeof window !== "undefined") {
      getConfigData();
    }
  }, []);
  const query1 = useQuery(Package_detail_Api, {
    variables: {
      categoryId: packageId != "" ? packageId : categorylist[0]?._id,
      packageType: "SUBSCRIPTION",
    },
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    if (packageId || categorylist[0]?._id) {
      trackEvent("subscription", {
        categoryId: packageId !== "" ? packageId : categorylist[0]?._id,
        packageType: "SUBSCRIPTION",
        url: window.location.href,
      });
    }
  }, [packageId, categorylist]);

  const query2 = useQuery(Package_detail_Api, {
    variables: {
      packageType: "VIBE",
    },
    fetchPolicy: "network-only",
  });
  const query3 = useQuery(Package_detail_Api, {
    variables: {
      packageType: "NOTES",
    },
    fetchPolicy: "network-only",
  });
  if (query1.loading || query2.loading || query3.loading)
    return (
      <>
        <Loader />
      </>
    );
  if (query1?.error || query2?.error || query3?.error) {
    if (
      query1?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "UNAUTHENTICATED"
      ) ||
      query2?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "UNAUTHENTICATED"
      ) ||
      query3?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "UNAUTHENTICATED"
      )
    ) {
      //   history.push('/login');
      authorizationCheck(navigate);
    } else if (
      query1?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "INTERNAL_SERVER_ERROR"
      ) ||
      query2?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "INTERNAL_SERVER_ERROR"
      ) ||
      query3?.error?.graphQLErrors.some(
        (e) => e?.extensions?.code === "INTERNAL_SERVER_ERROR"
      )
    ) {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <SomethingWentWrong pathName={location.pathname} />
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="main_wrapper">
            <div className="col-lg-12">
              <ConnectionError pathName={location.pathname} />
            </div>
          </div>
        </>
      );
    }
    console.log(query1.error);
    console.log(query2.error);
    console.log(query3.error);
  }

  const subscriptionApi = () => {
    query1.refetch({
      categoryId: categorylist[0]?._id,
      packageType: "SUBSCRIPTION",
    });
    if (categorylist[0]?.category?.indexOf("/")) {
      navigate(`/package/${(categorylist[0]?.category).replace(/\//g, "%2F")}`);
    } else {
      navigate(`/package/${categorylist[0]?.category}`);
    }
  };

  const checkEligibility = (id) => {
    // let EligibilityCriteria = await firebaseData('eligibility_criteria')
    // let data = JSON.parse(EligibilityCriteria)
    var keyName =
      id && EligibilityCriteriaData ? EligibilityCriteriaData[id] : null;
    if (keyName) {
      return true;
    } else {
      return false;
    }
  };
  console.log(process.env.REACT_APP_Razorpay_Key, "REACT_APP_Razorpay_Key")
  console.log(process.env.REACT_APP_RECAPTCHA_KEY, "REACT_APP_RECAPTCHA_KEY")
  const getAndSetCriteria = async (id) => {
    let criteriaData = EligibilityCriteriaData[id];
    if (criteriaData) {
      setCriteria(criteriaData);
      showPopupCriteria();
    }
  };
  const shoptab = () => {
    query2.refetch();
    query3.refetch();
    navigate("/package/shop");
  };
  const shopApi = () => {
    navigate("/account/myActivePlan");
  };

  const currentURL = window.location.href;

  // Split the URL by '/'
  const urlParts = currentURL.split("/").pop();
  return (
    <>
      <div className="main_wrapper">
        <div className="breadcrumbs">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item active">
              <a>Subscription</a>
            </li>
          </ul>
        </div>
        <section className="videoLayer_wrapper subscriptions_wrapper section_side_padding">
          <ToastContainer />
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="recommended_video_wrapper">
                <div className="subscription_ttl">
                  <h5>Subscriptions</h5>
                </div>
              </div>
              <div className="recommended_video_wrapper ">
                <div className="tabs_wrapper">
                  <div className="tabs_main">
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <a
                          className={`nav-link ${urlParts !== "shop" ? "active" : ""
                            }`}
                          data-toggle="tab"
                          href="#subscription_package"
                          onClick={subscriptionApi}
                        >
                          Subscription Package
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className={`nav-link ${urlParts === "shop" ? "active" : ""
                            }`}
                          data-toggle="tab"
                          href="#shop_package"
                          onClick={shoptab}
                        >
                          Shop Package
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="tab-content">
                    {
                      <div
                        className={`tab-pane ${urlParts !== "shop" ? "active" : "fade"
                          }`}
                        id="subscription_package"
                      >
                        <div className="subcription_inner_tabs">
                          <div className="tabs_main_wrap">
                            <div className="tabs_main">
                              <ul className="nav nav-tabs">
                                {categorylist
                                  ?.sort((a, b) => (a.index > b.index ? 1 : -1))
                                  .map(
                                    (d, i) =>
                                      d?.category !== undefined && (
                                        <li className="nav-item">
                                          <Link
                                            to={`/package/${d?.category?.indexOf("/")
                                              ? (d?.category).replace(
                                                /\//g,
                                                "%2F"
                                              )
                                              : d?.category
                                              }`}
                                            className={`nav-link ${name == d?.category
                                              ? "active"
                                              : ""
                                              }`}
                                            data-toggle="tab"
                                            href="#all_prof_plan"
                                            onClick={(e) => setData(d)}
                                          >
                                            {d?.category}
                                            {/* <a className={`nav-link ${name == (d.category != 'Proff/Foundation' ? d.category : 'Proff-Foundation') ? 'active' : ''}`} data-toggle="tab" href="#all_prof_plan" onClick={(e) => setData(i, d)}>{d.category}</a> */}
                                          </Link>
                                        </li>
                                      )
                                  )}
                                {/* <li className="nav-item">
                                                                <a className="nav-link" data-toggle="tab" href="#prof_wise_plan">Prof Wise Plan</a>
                                                            </li>
                                                            <li className="nav-item">
                                                                <a className="nav-link" data-toggle="tab" href="#live_plan">Live + eGurukul</a>
                                                            </li>
                                                            <li className="nav-item">
                                                                <a className="nav-link" data-toggle="tab" href="#spacial_plan">Special Plan</a>
                                                            </li> */}
                              </ul>
                            </div>
                          </div>
                          <div className="tab-content">
                            <div className="tab-pane active" id="all_prof_plan">
                              <div className="subscription_main_content">
                                <div className="row">
                                  {query1?.data &&
                                    query1?.data?.listPackagesForApp
                                      ?.slice()
                                      .sort((a, b) =>
                                        a.position > b.position ? 1 : -1
                                      )
                                      .map((data) => (
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                          <div
                                            className="plans_wrapper"
                                            style={{
                                              borderColor: `${data?.colorCode}`,
                                            }}
                                          >
                                            <div
                                              className="plans_header d-flex align-items-center"
                                              style={{
                                                background: `${data.colorCode}`,
                                              }}
                                            >
                                              <div className="plans_name">
                                                {(data?.packagePurchased
                                                  ?.transactionStatus ===
                                                  "COMPLETED" ||
                                                  data?.packagePurchased
                                                    ?.isAssignedPackageByAdmin ===
                                                  true) &&
                                                  data?.packagePurchased
                                                    ?.hasExpired === false && (
                                                    <div className="plan_tag d-flex">
                                                      <h6>{data?.title}</h6>
                                                      <span>Purchased</span>
                                                    </div>
                                                  )}
                                                {data?.packagePurchased
                                                  ?.hasExpired === true && (
                                                    <div className="plan_tag d-flex">
                                                      <h6>{data?.title}</h6>
                                                    </div>
                                                  )}
                                                {/* {
                                                                                                data?.packagePurchased?.isAssignedPackageByAdmin === true && data?.packagePurchased?.hasExpired===false &&
                                                                                                <div className="plan_tag d-flex">
                                                                                                    <h6>{data?.title}</h6>
                                                                                                    <span>Purchased</span>
                                                                                                </div>
                                                                                                // <h6>{data.title} <span>Purchased</span></h6>
                                                                                            } */}
                                                {data?.packagePurchased ===
                                                  null && (
                                                    <h6>{data?.title}</h6>
                                                  )}
                                                <p>{data?.subtitle}</p>
                                              </div>
                                              <div className="plan_price">
                                                <h6>
                                                  <span>Starts From</span> ₹
                                                  {data.validity[0]
                                                    ?.discountPrice !== 0
                                                    ? data.validity[0]
                                                      ?.discountPrice
                                                    : data.validity[0]?.mrp}
                                                </h6>
                                                {data?.validity[0]
                                                  ?.discountPrice !== 0 && (
                                                    <p>
                                                      <del>
                                                        ₹ {data.validity[0]?.mrp}
                                                      </del>
                                                    </p>
                                                  )}
                                                {/* <p>valid till{data.validity[0].mrp}</p> */}
                                              </div>
                                            </div>
                                            <div className="plans_body">
                                              <ul type="none">
                                                {data?.newDescription &&
                                                  data?.newDescription.map(
                                                    (i) => <li>{i}</li>
                                                  )}
                                                {/* <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                            <li>Make your own Qbank with Custom Qbank module</li> */}
                                              </ul>
                                            </div>
                                            <div className="plans_footer d-flex justify-content-between align-items-center">
                                              <div className="footer_child_left">
                                                {
                                                  // (data?.packagePurchased?.boughtWithNotes != true || data?.packagePurchased?.boughtWithVibe != true) && data?.packagePurchased?.hasExpired === false &&
                                                  // data.validity.map(obj => (
                                                  //     obj._id.toString() == data?.packagePurchased?.validityId && (((obj.withNotes || obj.withPenDrive) && (data?.packagePurchased?.boughtWithNotes != obj.withNotes || data?.packagePurchased?.boughtWithVibe != obj.withPenDrive)) && data?.packagePurchased?.isAssignedPackageByAdmin != true) && data?.packagePurchased?.transactionStatus === 'COMPLETED' &&
                                                  //     <Link to={`/package/Addons/${data._id}`}>
                                                  //         <button type="button" className="btn btsubscriptionn_addons btn_addons" style={{ background: `${data?.colorCode? data?.colorCode:"rgb(237, 248, 241)"}` }}>Buy Add Ons</button>
                                                  //     </Link>
                                                  // ))
                                                }
                                                {
                                                  // extend && extend.map(obj => (
                                                  ((data?.packagePurchased !==
                                                    null &&
                                                    data?.packageExtension !=
                                                    null) ||
                                                    data?.packagePurchased
                                                      ?.hasExpired == true) &&
                                                  data?.isAvailableExtension ==
                                                  true && (
                                                    // <Link to={`/package/extension`} state={JSON.stringify(data)}>
                                                    <a href="javascript:;">
                                                      <button
                                                        type="button"
                                                        className="btn btn_addons"
                                                        style={{
                                                          background: `${data?.colorCode
                                                            ? data.colorCode
                                                            : "rgb(237, 248, 241)"
                                                            }`,
                                                        }}
                                                        onClick={() =>
                                                          navigateToPlanAddons(
                                                            data
                                                          )
                                                        }
                                                      >
                                                        Extend Plan
                                                      </button>
                                                    </a>
                                                  )
                                                  // </Link>
                                                  // ))
                                                }
                                                {((data?.packagePurchased !==
                                                  null &&
                                                  data?.packageExtension !=
                                                  null) ||
                                                  data?.packagePurchased
                                                    ?.hasExpired == true) &&
                                                  data?.isAvailableExtension ==
                                                  true &&
                                                  checkEligibility(data?._id) ==
                                                  true && (
                                                    <a
                                                      href="javascript:;"
                                                      className="eligible_criteria"
                                                      onClick={() =>
                                                        getAndSetCriteria(
                                                          data?._id
                                                        )
                                                      }
                                                    >
                                                      Eligibility
                                                      <br />
                                                      Criteria
                                                    </a>
                                                  )}
                                              </div>
                                              <div className="footer_child_right">
                                                <h6>
                                                  {data?.packagePurchased ===
                                                    null ||
                                                    (data?.packagePurchased
                                                      ?.hasExpired === true && (
                                                        <a href="javascript:;">
                                                          <Link
                                                            to={`/package/plan/${data._id}`}
                                                          >
                                                            Buy Now{" "}
                                                            <img
                                                              src={
                                                                Icons.ArrowBlue
                                                              }
                                                              alt=""
                                                              className="img-fluid"
                                                            />
                                                          </Link>
                                                        </a>
                                                      ))}
                                                  {data?.packagePurchased ===
                                                    null && (
                                                      <a href="javascript:;">
                                                        <Link
                                                          to={`/package/plan/${data._id}`}
                                                        >
                                                          Buy Now{" "}
                                                          <img
                                                            src={Icons.ArrowBlue}
                                                            alt=""
                                                            className="img-fluid"
                                                          />
                                                        </Link>
                                                      </a>
                                                    )}
                                                </h6>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                  {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="plans_wrapper">
                                                                        <div className="plans_header d-flex align-items-center">
                                                                            <div className="plans_name">
                                                                                <h6>Basic Plus<span>Active</span></h6>
                                                                                <p>QB+Test Series</p>
                                                                            </div>
                                                                            <div className="plan_price">
                                                                                <h6><span>Starts From</span> ₹9,749</h6>
                                                                                <p>20% off <del>₹ 12,107</del></p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="plans_body">
                                                                            <ul type="none">
                                                                                <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                                                <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                                <li>Make your own Qbank with Custom Qbank module</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="plans_footer text-right">
                                                                            <h6>
                                                                                <a href="javascript:;">
                                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                </a> 
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                </div>
                              </div>
                            </div>
                            {/* <div className="tab-pane fade" id="prof_wise_plan">
                                                        <div className="subscription_main_content">
                                                            <div className="row">
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="plans_wrapper">
                                                                        <div className="plans_header d-flex align-items-center">
                                                                            <div className="plans_name">
                                                                                <h6>Basic Plus</h6>
                                                                                <p>QB+Test Series</p>
                                                                            </div>
                                                                            <div className="plan_price">
                                                                                <h6><span>Starts From</span> ₹9,749</h6>
                                                                                <p>20% off <del>₹ 12,107</del></p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="plans_body">
                                                                            <ul type="none">
                                                                                <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                                                <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                                <li>Make your own Qbank with Custom Qbank module</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="plans_footer text-right">
                                                                            <h6>
                                                                                <a href="javascript:;">
                                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                </a> 
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="plans_wrapper">
                                                                        <div className="plans_header d-flex align-items-center">
                                                                            <div className="plans_name">
                                                                                <h6>Basic Plus<span>Active</span></h6>
                                                                                <p>QB+Test Series</p>
                                                                            </div>
                                                                            <div className="plan_price">
                                                                                <h6><span>Starts From</span> ₹9,749</h6>
                                                                                <p>20% off <del>₹ 12,107</del></p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="plans_body">
                                                                            <ul type="none">
                                                                                <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                                                <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                                <li>Make your own Qbank with Custom Qbank module</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="plans_footer text-right">
                                                                            <h6>
                                                                                <a href="javascript:;">
                                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                </a> 
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </div>
                                                    </div>
                                                    <div className="tab-pane fade" id="live_plan">
                                                        <div className="subscription_main_content">
                                                            <div className="row">
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="plans_wrapper">
                                                                        <div className="plans_header d-flex align-items-center">
                                                                            <div className="plans_name">
                                                                                <h6>Basic Plus</h6>
                                                                                <p>QB+Test Series</p>
                                                                            </div>
                                                                            <div className="plan_price">
                                                                                <h6><span>Starts From</span> ₹9,749</h6>
                                                                                <p>20% off <del>₹ 12,107</del></p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="plans_body">
                                                                            <ul type="none">
                                                                                <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                                                <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                                <li>Make your own Qbank with Custom Qbank module</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="plans_footer text-right">
                                                                            <h6>
                                                                                <a href="javascript:;">
                                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                </a> 
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="plans_wrapper">
                                                                        <div className="plans_header d-flex align-items-center">
                                                                            <div className="plans_name">
                                                                                <h6>Basic Plus<span>Active</span></h6>
                                                                                <p>QB+Test Series</p>
                                                                            </div>
                                                                            <div className="plan_price">
                                                                                <h6><span>Starts From</span> ₹9,749</h6>
                                                                                <p>20% off <del>₹ 12,107</del></p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="plans_body">
                                                                            <ul type="none">
                                                                                <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                                                <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                                <li>Make your own Qbank with Custom Qbank module</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="plans_footer text-right">
                                                                            <h6>
                                                                                <a href="javascript:;">
                                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                </a> 
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane fade" id="spacial_plan">
                                                        <div className="subscription_main_content">
                                                            <div className="row">
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="plans_wrapper">
                                                                        <div className="plans_header d-flex align-items-center">
                                                                            <div className="plans_name">
                                                                                <h6>Basic Plus</h6>
                                                                                <p>QB+Test Series</p>
                                                                            </div>
                                                                            <div className="plan_price">
                                                                                <h6><span>Starts From</span> ₹9,749</h6>
                                                                                <p>20% off <del>₹ 12,107</del></p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="plans_body">
                                                                            <ul type="none">
                                                                                <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                                                <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                                <li>Make your own Qbank with Custom Qbank module</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="plans_footer text-right">
                                                                            <h6>
                                                                                <a href="javascript:;">
                                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                </a> 
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="plans_wrapper">
                                                                        <div className="plans_header d-flex align-items-center">
                                                                            <div className="plans_name">
                                                                                <h6>Basic Plus<span>Active</span></h6>
                                                                                <p>QB+Test Series</p>
                                                                            </div>
                                                                            <div className="plan_price">
                                                                                <h6><span>Starts From</span> ₹9,749</h6>
                                                                                <p>20% off <del>₹ 12,107</del></p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="plans_body">
                                                                            <ul type="none">
                                                                                <li>39000+ latest Pattern MCQs as per the 2021-2022 Pattern</li>
                                                                                <li>292 Tests, 43 Grand test & 62 Subject wise tests attempted by 1Lakh students</li>
                                                                                <li>Questions curated by DBMCI/eGurukul faculties</li>
                                                                                <li>To the point explanation.</li>
                                                                                <li>Make your own Qbank with Custom Qbank module</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="plans_footer text-right">
                                                                            <h6>
                                                                                <a href="javascript:;">
                                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                </a> 
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                          </div>
                        </div>

                        {query1.data?.listPackagesForApp?.length === 0 && (
                          <NoDataFound />
                        )}
                      </div>
                    }
                    {
                      <div
                        className={`tab-pane  ${urlParts === "shop" ? "active" : "fade"
                          }`}
                        id="shop_package"
                      >
                        <div className="subcription_inner_tabs">
                          <div className="tabs_main_wrap">
                            <div className="tabs_main">
                              <ul className="nav nav-tabs">
                                <li className="nav-item">
                                  {config?.EshopList?.map(
                                    (obj, i) =>
                                      obj?._id == "NOTES" && (
                                        <a
                                          className="nav-link active"
                                          data-toggle="tab"
                                          href="#note_plan"
                                        >
                                          {obj?.name}
                                        </a>
                                      )
                                  )}
                                </li>
                                <li className="nav-item">
                                  {config?.EshopList?.map(
                                    (obj, i) =>
                                      obj?._id == "VIBE" && (
                                        <a
                                          className="nav-link "
                                          data-toggle="tab"
                                          href="#vibe_plan"
                                        >
                                          {obj?.name}
                                        </a>
                                      )
                                  )}
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="tab-content">
                            <div className="tab-pane fade" id="vibe_plan">
                              <div className="subscription_main_content">
                                <div className="row">
                                  {query2.data &&
                                    query2.data?.listPackagesForApp.map(
                                      (obj, i) => (
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                          <div
                                            className="plans_wrapper"
                                            style={{
                                              borderColor: `${obj?.colorCode != null
                                                ? obj?.colorCode
                                                : "rgb(173, 216, 230)"
                                                }`,
                                            }}
                                          >
                                            <div
                                              className="plans_header d-flex align-items-center"
                                              style={{
                                                background: `${obj?.colorCode != null
                                                  ? obj?.colorCode
                                                  : "rgb(173, 216, 230)"
                                                  }`,
                                              }}
                                            >
                                              <div className="plans_name">
                                                {obj?.packagePurchased
                                                  ?.transactionStatus ===
                                                  "COMPLETED" && (
                                                    <div className="plan_tag d-flex">
                                                      <h6>{obj?.title}</h6>
                                                      <span>Purchased</span>
                                                    </div>
                                                  )}
                                                {obj?.packagePurchased ===
                                                  null &&
                                                  obj
                                                    ?.recommendedSubscriptionForAddOn
                                                    ?.boughtWithNotes == true &&
                                                  obj
                                                    ?.recommendedSubscriptionForAddOn
                                                    ?.boughtWithVibe ==
                                                  true && (
                                                    <div className="plan_tag d-flex">
                                                      <h6>{obj?.title}</h6>
                                                      <span>Purchased</span>
                                                    </div>
                                                  )}
                                                {obj?.packagePurchased ===
                                                  null &&
                                                  (obj
                                                    ?.recommendedSubscriptionForAddOn
                                                    ?.boughtWithNotes ==
                                                    false ||
                                                    obj
                                                      ?.recommendedSubscriptionForAddOn
                                                      ?.boughtWithVibe ==
                                                    false) && (
                                                    <h6>{obj?.title}</h6>
                                                  )}
                                                {obj?.packagePurchased ===
                                                  null &&
                                                  obj?.recommendedSubscriptionForAddOn ==
                                                  null && (
                                                    <h6>{obj?.title}</h6>
                                                  )}
                                                {/* <h6>{obj.title}</h6> */}
                                                <p>{obj?.subtitle}</p>
                                              </div>
                                              {obj?.recommendedSubscriptionForAddOn ===
                                                null && (
                                                  <div className="plan_price">
                                                    <h6>
                                                      ₹
                                                      {obj?.validity[0]
                                                        ?.discountPrice != 0
                                                        ? obj.validity[0]
                                                          ?.discountPrice
                                                        : obj.validity[0]?.mrp}
                                                    </h6>
                                                    {/* <p>20% off <del>₹ 2,107</del></p> */}
                                                    {obj?.validity[0]
                                                      .discountPrice != 0 && (
                                                        <p>
                                                          <del>
                                                            ₹ {obj.validity[0]?.mrp}
                                                          </del>
                                                        </p>
                                                      )}
                                                  </div>
                                                )}
                                              {obj?.recommendedSubscriptionForAddOn !==
                                                null && (
                                                  <div className="plan_price">
                                                    <h6>
                                                      ₹
                                                      {obj
                                                        ?.recommendedSubscriptionForAddOn
                                                        ?.planPurchased?.vibe
                                                        ?.afterBuyPendriveDiscount
                                                        ? obj
                                                          ?.recommendedSubscriptionForAddOn
                                                          ?.planPurchased?.vibe
                                                          ?.afterBuyPendriveDiscount
                                                        : obj
                                                          ?.recommendedSubscriptionForAddOn
                                                          ?.planPurchased?.vibe
                                                          ?.afterBuyPendrivePrice}
                                                    </h6>
                                                    {/* <p>20% off <del>₹ 2,107</del></p> */}
                                                    {obj
                                                      ?.recommendedSubscriptionForAddOn
                                                      ?.planPurchased?.vibe
                                                      ?.afterBuyPendriveDiscount !==
                                                      0 && (
                                                        <p>
                                                          <del>
                                                            ₹{" "}
                                                            {
                                                              obj
                                                                ?.recommendedSubscriptionForAddOn
                                                                ?.planPurchased
                                                                ?.vibe
                                                                ?.afterBuyPendrivePrice
                                                            }
                                                          </del>
                                                        </p>
                                                      )}
                                                  </div>
                                                )}
                                            </div>
                                            <div className="plans_body">
                                              <ul type="none">
                                                {obj?.newDescription &&
                                                  obj?.newDescription.map(
                                                    (i) => <li>{i}</li>
                                                  )}
                                              </ul>
                                            </div>
                                            <div className="plans_footer text-right">
                                              <h6>
                                                {obj?.packagePurchased ===
                                                  null &&
                                                  obj?.recommendedSubscriptionForAddOn ===
                                                  null && (
                                                    <Link
                                                      to={`/package/planAddons/${obj._id}`}
                                                      state={"VIBE"}
                                                    >
                                                      <h6>
                                                        <a href="javascript:;">
                                                          Buy Now{" "}
                                                          <img
                                                            src={
                                                              Icons.ArrowBlue
                                                            }
                                                            alt=""
                                                            className="img-fluid"
                                                          />
                                                        </a>
                                                      </h6>
                                                    </Link>
                                                  )}
                                                {obj?.packagePurchased ===
                                                  null &&
                                                  (obj
                                                    ?.recommendedSubscriptionForAddOn
                                                    ?.boughtWithNotes ===
                                                    false ||
                                                    obj
                                                      ?.recommendedSubscriptionForAddOn
                                                      ?.boughtWithVibe ===
                                                    false) && (
                                                    <Link
                                                      to={`/package/planAddons/${obj._id}`}
                                                      state={"VIBE"}
                                                    >
                                                      <h6>
                                                        <a href="javascript:;">
                                                          Buy Now{" "}
                                                          <img
                                                            src={
                                                              Icons.ArrowBlue
                                                            }
                                                            alt=""
                                                            className="img-fluid"
                                                          />
                                                        </a>
                                                      </h6>
                                                    </Link>
                                                  )}
                                                {/* <a href="javascript:;">
                                                                                                Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid"/>
                                                                                            </a>  */}
                                              </h6>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane active " id="note_plan">
                              <div className="subscription_main_content">
                                <div className="row">
                                  {query3.data?.listPackagesForApp?.map(
                                    (ob, i) => (
                                      // obj.type==2 &&
                                      // shop && shop[i]?.package?.map(ob => (
                                      <div className="col-lg-4 col-md-6 col-sm-12">
                                        <div
                                          className="plans_wrapper"
                                          style={{
                                            borderColor: `${ob?.colorCode != null
                                              ? ob?.colorCode
                                              : "rgb(173, 216, 230)"
                                              }`,
                                          }}
                                        >
                                          <div
                                            className="plans_header d-flex align-items-center"
                                            style={{
                                              background: `${ob?.colorCode != null
                                                ? ob?.colorCode
                                                : "rgb(173, 216, 230)"
                                                }`,
                                            }}
                                          >
                                            <div className="plans_name">
                                              {ob?.packagePurchased
                                                ?.transactionStatus ===
                                                "COMPLETED" && (
                                                  <div className="plan_tag d-flex">
                                                    <h6>{ob?.title}</h6>
                                                    <span>Purchased</span>
                                                  </div>
                                                )}
                                              {ob?.packagePurchased === null &&
                                                ob
                                                  ?.recommendedSubscriptionForAddOn
                                                  ?.boughtWithNotes == true &&
                                                ob
                                                  ?.recommendedSubscriptionForAddOn
                                                  ?.boughtWithVibe == true && (
                                                  <div className="plan_tag d-flex">
                                                    <h6>{ob?.title}</h6>
                                                    <span>Purchased</span>
                                                  </div>
                                                )}
                                              {ob?.packagePurchased === null &&
                                                (ob
                                                  ?.recommendedSubscriptionForAddOn
                                                  ?.boughtWithNotes == false ||
                                                  ob
                                                    ?.recommendedSubscriptionForAddOn
                                                    ?.boughtWithVibe ==
                                                  false) && (
                                                  <h6>{ob?.title}</h6>
                                                )}
                                              {ob?.packagePurchased === null &&
                                                ob?.recommendedSubscriptionForAddOn ==
                                                null && <h6>{ob?.title}</h6>}
                                              <p>{ob?.subtitle}</p>
                                            </div>
                                            {ob?.recommendedSubscriptionForAddOn ===
                                              null && (
                                                <div className="plan_price">
                                                  <h6>
                                                    ₹
                                                    {ob?.validity[0]
                                                      ?.discountPrice != 0
                                                      ? ob?.validity[0]
                                                        ?.discountPrice
                                                      : ob?.validity[0]?.mrp}
                                                  </h6>
                                                  {ob?.validity[0]
                                                    ?.discountPrice != 0 && (
                                                      <p>
                                                        <del>
                                                          ₹ {ob?.validity[0]?.mrp}
                                                        </del>
                                                      </p>
                                                    )}
                                                </div>
                                              )}
                                            {ob?.recommendedSubscriptionForAddOn !==
                                              null && (
                                                <div className="plan_price">
                                                  <h6>
                                                    ₹
                                                    {ob
                                                      ?.recommendedSubscriptionForAddOn
                                                      ?.planPurchased?.notes
                                                      ?.afterBuyNotesDiscount != 0
                                                      ? ob
                                                        ?.recommendedSubscriptionForAddOn
                                                        ?.planPurchased?.notes
                                                        ?.afterBuyNotesDiscount
                                                      : ob
                                                        ?.recommendedSubscriptionForAddOn
                                                        ?.planPurchased?.notes
                                                        ?.afterBuyNotesPrice}
                                                  </h6>
                                                  {/* <p>20% off <del>₹ 2,107</del></p> */}
                                                  {ob
                                                    ?.recommendedSubscriptionForAddOn
                                                    ?.planPurchased?.notes
                                                    ?.afterBuyNotesDiscount !=
                                                    0 && (
                                                      <p>
                                                        <del>
                                                          ₹{" "}
                                                          {
                                                            ob
                                                              ?.recommendedSubscriptionForAddOn
                                                              ?.planPurchased?.notes
                                                              ?.afterBuyNotesPrice
                                                          }
                                                        </del>
                                                      </p>
                                                    )}
                                                </div>
                                              )}
                                          </div>
                                          <div className="plans_body">
                                            <ul type="none">
                                              {ob?.newDescription &&
                                                ob?.newDescription.map((i) => (
                                                  <li>{i}</li>
                                                ))}
                                            </ul>
                                          </div>
                                          <div className="plans_footer text-right">
                                            <h6>
                                              {ob?.packagePurchased === null &&
                                                ob.recommendedSubscriptionForAddOn ===
                                                null && (
                                                  <Link
                                                    to={`/package/planAddons/${ob?._id}`}
                                                    state={"NOTES"}
                                                  >
                                                    <a href="javascript:;">
                                                      Buy Now{" "}
                                                      <img
                                                        src={Icons.ArrowBlue}
                                                        alt=""
                                                        className="img-fluid"
                                                      />
                                                    </a>
                                                  </Link>
                                                )}
                                              {ob?.packagePurchased === null &&
                                                (ob
                                                  ?.recommendedSubscriptionForAddOn
                                                  ?.boughtWithNotes === false ||
                                                  ob
                                                    ?.recommendedSubscriptionForAddOn
                                                    ?.boughtWithVibe ===
                                                  false) && (
                                                  <Link
                                                    to={`/package/planAddons/${ob?._id}`}
                                                    state={"NOTES"}
                                                  >
                                                    <a href="javascript:;">
                                                      Buy Now{" "}
                                                      <img
                                                        src={Icons.ArrowBlue}
                                                        alt=""
                                                        className="img-fluid"
                                                      />
                                                    </a>
                                                  </Link>
                                                )}
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {(query3?.data?.listPackagesForApp.length == 0 ||
                          query2?.data.listPackagesForApp.length == 0) && (
                            <NoDataFound />
                          )}
                      </div>
                    }
                  </div>
                  {
                    <div className="manage_subscriptions">
                      <a className="nav-link" onClick={shopApi}>
                        Manage My Subscription
                        <img
                          src={Icons.ArrowBlue}
                          alt=""
                          className="img-fluid"
                        />
                      </a>
                    </div>
                  }
                </div>
              </div>
            </div>

            {/* <div className="col-lg-4 col-md-4 col-sm-12"> */}
            {/* <div className="videos_wrapper">
                                <div className="buy_packages d-flex align-items-center">
                                    <div className="package_text">
                                        <h6>Buy Package</h6>
                                        <p>Buy Package to unlock content and Start Learning</p>
                                    </div>
                                    <div className="package_img">
                                        <img src={Images.Package} alt="" className="img-fluid"/>
                                    </div>
                                </div>
                            </div> */}
            {/* </div> */}
          </div>
        </section>
      </div>
      {criteria && (
        <Modal
          show={showPopup}
          onHide={hidePopup}
          backdrop="static"
          className="detail_modal report_modal device_reached eligibilty_criteria_modal"
          centered
        >
          <Modal.Body>
            <div className="account_option_wrapper">
              <div className="cross_icon text-right">
                <img
                  src={Icons.ModalCross}
                  alt=""
                  className="img-fluid"
                  onClick={hidePopup}
                />
              </div>
              <div className="account_header">
                <h6 className="text-center">{criteria?.title}</h6>
                <div className="plans_body">
                  <ul type="none">
                    {criteria?.Description.map((item, index) => (
                      <>
                        {/* <li  key={index}><img src={Icons.TickCircle} alt="" />{item}</li> */}
                        <li key={index} className="d-flex align-items-baseline">
                          <div className="criteria_body_img">
                            <img src={Icons.ArrowBlue} alt="" />
                          </div>
                          <div className="criteria_body_txt">
                            <p>{item}</p>
                          </div>
                        </li>
                      </>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="rating_submit">
              <button
                type="button"
                className="btn btn_theme btn_border"
                onClick={hidePopup}
              >
                {criteria?.cta1}
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
  // }
}
